import actionCreator from '../../createAction';

const createAction = actionCreator('modals');

export const SHOW_MOBILE_NAV = createAction('SHOW_MOBILE_NAV');
export const HIDE_MOBILE_NAV = createAction('HIDE_MOBILE_NAV');
export const SHOW_CREATE_INBOX = createAction('SHOW_CREATE_INBOX');
export const HIDE_CREATE_INBOX = createAction('HIDE_CREATE_INBOX');
export const TOGGLE_CREATE_MESSAGE = createAction('TOGGLE_CREATE_MESSAGE');
export const TOGGLE_NEW_WORKFLOW_MODAL = createAction(
  'TOGGLE_NEW_WORKFLOW_MODAL',
);

export const TOGGLE_DIALER = createAction('TOGGLE_DIALER');

export const SHOW_10DLC_BANNER = createAction('SHOW_10DLC_BANNER');
export const HIDE_10DLC_BANNER = createAction('HIDE_10DLC_BANNER');
